import { createContext } from 'react';

const TranslationContext = createContext({});

export { TranslationContext };
